export default __webpack_public_path__ + "static/webdev-4accdd8ef27a9c51f3646be608a8f107.jpg";